import { __extends } from 'tslib';
import * as React from 'react';
import { Viewport, ViewExtraLarge } from '@shared-ui/viewport-context';
import { UitkLayoutGrid, MinMax, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-view.css';
import { UitkView } from './uitk-view.esm.js';
import { UitkViewRow } from './uitk-view-row.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkViewTemplateInfosite = /** @class */ (function (_super) {
    __extends(UitkViewTemplateInfosite, _super);
    function UitkViewTemplateInfosite() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkViewTemplateInfosite.prototype.render = function () {
        var _a = this.props, stepIndicator = _a.stepIndicator, detailsReview = _a.detailsReview, priceBreakdown = _a.priceBreakdown, banners = _a.banners, legalInfo = _a.legalInfo, sideRailAd = _a.sideRailAd, adSection = _a.adSection, canvasTheme = _a.canvasTheme;
        return (React.createElement(UitkView, null,
            React.createElement(UitkSpacing, { margin: { blockstart: 'six' } },
                React.createElement(UitkViewRow, { canvasTheme: canvasTheme !== null && canvasTheme !== void 0 ? canvasTheme : 'secondary', layout: "centered", adSlot: !!sideRailAd },
                    React.createElement(UitkLayoutGrid, { columns: { large: [MinMax('0x', '2fr'), MinMax('0x', '1fr')] }, space: "six", alignItems: "start", tag: "main" },
                        React.createElement(UitkLayoutGridItem, { colSpan: "all" },
                            React.createElement("section", null, stepIndicator)),
                        React.createElement(UitkLayoutGridItem, null,
                            React.createElement(UitkLayoutGrid, { space: "six" },
                                banners && (React.createElement("section", { className: getClassNameList(banners.isHidden ? 'is-hidden' : '') }, banners.content ? banners.content : banners)),
                                React.createElement(UitkLayoutGridItem, null,
                                    React.createElement("section", null, detailsReview)),
                                legalInfo && (React.createElement(UitkLayoutGridItem, null,
                                    React.createElement("section", null, legalInfo))))),
                        React.createElement(UitkLayoutGridItem, null,
                            React.createElement("section", null, priceBreakdown)),
                        React.createElement(UitkLayoutGridItem, null,
                            React.createElement("section", null, adSection))),
                    sideRailAd && (React.createElement(Viewport, null,
                        React.createElement(ViewExtraLarge, null, sideRailAd)))))));
    };
    UitkViewTemplateInfosite.displayName = 'UitkViewTemplateInfosite';
    return UitkViewTemplateInfosite;
}(React.Component));

export { UitkViewTemplateInfosite };
